<template>
  <b-card title="Estetty alueet">
    <!-- Table Content -->
    <b-table
      ref="refBlockedFromListTable"
      :items="items"
      responsive
      :fields="tableColumns"
      show-empty
      :empty-text="$t('no_matching_records')"
      class="position-relative"
    >
      <!-- Column: date -->
      <template #cell(date)="{ value }">
        <span class="font-weight-bold">
          {{
            value
              .toDate()
              .toLocaleString('fi', { day: '2-digit', month: '2-digit', year: '2-digit' })
          }}
        </span>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BCard, BTable } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import i18n from '@hw-core/libs/i18n'
import { getAreaById } from '@/shared/services/areaService' // TODO use alias
import { getAccountById } from '@/shared/services/accountService' // TODO use alias

export default {
  components: {
    BCard,
    BTable,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const refBlockedFromListTable = ref(null)
    const tableColumns = ref([
      {
        label: i18n.t('personel.table.headers.blockedFrom'),
        key: 'blockName',
        class: 'capitalized',
      },
      { label: i18n.t('personel.table.headers.processer'), key: 'processer', class: 'capitalized' },
      { label: i18n.t('personel.table.headers.blockReason'), key: 'blockReason' },
      { label: i18n.t('personel.table.headers.date'), key: 'date' },
    ])
    const items = ref([])

    const fetchBlockedFromData = async () => {
      const blockedFrom = props.userData.blockedFrom.filter(
        i => i.type === 'account' || i.type === 'area'
      )

      items.value = await Promise.all(
        blockedFrom.map(async item => {
          if (item.type === 'account') {
            const account = await getAccountById(item.blockId)
            return { ...item, blockName: account.name }
          }
          if (item.type === 'area') {
            const area = await getAreaById(item.blockId)
            return { ...item, blockName: area.name }
          }
          return { item, blockName: '' }
        })
      )
    }

    fetchBlockedFromData()

    return {
      refBlockedFromListTable,
      tableColumns,
      items,
    }
  },
}
</script>

<style></style>
